import {COORDINATES_MADRID_3857} from '@/api/util-coordinates';
import {DEFAULT_SCREEN_DPC, DEFAULT_PRINT_DPC, dpi2dpc} from '@/util-scale';
import {useCookies} from '@vueuse/integrations/useCookies';

const {set: setCookie, get: getCookie} = useCookies(['map-dpc'], {doNotParse: true});

const dpcCookieRaw = getCookie('map-dpc');
const dpcCookie = parseFloat(dpcCookieRaw);

// #region Actions
const actions = {
  async setCenter({commit}, {center}) {
    commit('setMapCenter', {center});
  },
  async setZoom({commit}, {zoom}) {
    commit('setMapZoom', {zoom});
  },
  async setScale({commit}, {meters}) {
    commit('setMapScale', {meters});
  },
  async setMapExtent({commit}, {extent}) {
    if (!!extent) {
      commit('setMapExtent', {userExtent: extent});
    }
  },
  async setScreenDPI({commit}, {screenDPI}) {
    const dpi = parseFloat(screenDPI);
    const screenDPCNumber = dpi2dpc(dpi);
    if (!!screenDPCNumber) {
      setCookie('map-dpc', screenDPCNumber);
      commit('setScreenDPC', {screenDPC: screenDPCNumber});
    }
  },
  async setScreenDPC({commit}, {screenDPC}) {
    const screenDPCNumber = parseFloat(screenDPC);
    if (!!screenDPCNumber) {
      setCookie('map-dpc', screenDPCNumber);
      commit('setScreenDPC', {screenDPC: screenDPCNumber});
    }
  },
  async printMap({commit}) {
    commit('printMap');
  },
  async setMeasureMode({commit}, measureMode) {
    commit('setMeasureMode', measureMode);
  },
  async setSelectedIdStops({commit}, selectedIdStops) {
    commit('setSelectedIdStops', selectedIdStops);
  },
  async setCenterMapDraw({commit}, centerMapDraw) {
    commit('setCenterMapDraw', centerMapDraw);
  },
};
// #endregion

// #region Getters
const getters = {
  getSelectedIdStops: (state) => {
    return Object.keys(state.selectedIdStops);
  },
};
// #endregion

// #region Mutations
const mutations = {
  setMapCenter(state, {center}) {
    state.center = center;
  },
  setMapZoom(state, {zoom}) {
    state.zoom = zoom;
  },
  setMapScale(state, {meters}) {
    state.mapScaleMeters = meters;
    state.triggerScale = Math.random() * 1; // Set trigger
  },
  setMapExtent(state, {userExtent}) {
    state.userExtent = userExtent;
    state.triggerExtent = Math.random() * 1; // Set trigger
  },
  setScreenDPC(state, {screenDPC}) {
    state.screenDPC = screenDPC;
    state.dpcSource = 'user'; // Set by user
  },
  printMap(state) {
    state.triggerPrint = Math.random() * 1; // Set trigger
  },
  setMeasureMode(state, measureMode) {
    let effectiveMode = measureMode;
    if (measureMode === state.measureMode) {
      effectiveMode = 0;
    }
    state.measureMode = effectiveMode;
  },
  setCenterMapDraw(state, centerMapDraw) {
    state.centerMapDraw = centerMapDraw;
  },
  setSelectedIdStops(state, selectedIdStops) {
    state.selectedIdStops = selectedIdStops;
  },
};
// #endregion

// #region State
// const coordMadrid = [443478.7, 4474446]; // srs 25830
const state = () => {
  return {
    center: COORDINATES_MADRID_3857,
    zoom: 5,
    dpcSource: !!dpcCookie ? 'user' : 'default', // Source of DPC data
    screenDPC: !!dpcCookie ? dpcCookie : DEFAULT_SCREEN_DPC,
    printDPC: DEFAULT_PRINT_DPC,
    printDimensions: [297, 210],
    printMargins: [5, 5],
    mapScaleMeters: null,
    triggerScale: null,
    userExtent: [],
    triggerExtent: null,
    triggerPrint: null,
    measureMode: 0, // 1: Distance, 2: Area
    centerMapDraw: false,
    selectedIdStops: null,
  };
};
// #endregion


// #region Etc
const namespaced = true;
const modules = []; // Submodules
// #endregion


export default {
  actions,
  getters,
  modules,
  mutations,
  namespaced,
  state,
};
